"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnumValueDefinitionTemplate = void 0;
const TemplateUtils_1 = require("./TemplateUtils");
class EnumValueDefinitionTemplate {
    static resolve(f) {
        return `${TemplateUtils_1.TemplateUtils.descriptionResolver(f.description, 1)}\t${f.name}${TemplateUtils_1.TemplateUtils.resolveDirectives(f.directives)}`;
    }
}
exports.EnumValueDefinitionTemplate = EnumValueDefinitionTemplate;
